module.exports = __webpack_public_path__ + "static/media/bg.f963e911.png";